import { createSlice } from '@reduxjs/toolkit';

export interface InvalidTokenModalState {
    show: boolean;
}

const initialState: InvalidTokenModalState = {
    show: false
};

export const invalidTokenModalSlice = createSlice({
    name: 'invalidTokenModal',
    initialState: initialState,
    reducers: {
        showModal: (state) => {
            state.show = true;
        },
        closeModal: (state) => {
            state.show = false;
        }
    }
});

export const invalidTokenModalActions = invalidTokenModalSlice.actions;

export default invalidTokenModalSlice.reducer;
